/**
 * API configuration utilities
 */

/**
 * Get the base URL for API requests
 * @returns {string} The base URL for API requests
 */
export const getApiBaseUrl = () => {
  // In development, use the environment variable or default to localhost:9900
  const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:9900';
  
  // Return the base URL without trailing slash
  return apiUrl.endsWith('/') ? apiUrl.slice(0, -1) : apiUrl;
};

/**
 * API endpoints configuration
 */
export const endpoints = {
  auth: {
    login: '/auth/login',
    register: '/auth/register',
    logout: '/auth/logout',
    refresh: '/auth/refresh'
  },
  brands: {
    list: '/brands',
    create: '/brands',
    get: (id) => `/brands/${id}`,
    update: (id) => `/brands/${id}`,
    delete: (id) => `/brands/${id}`
  }
};

/**
 * Format error message from API response
 * @param {Error} error - The error object
 * @returns {string} Formatted error message
 */
export const formatErrorMessage = (error) => {
  if (error.response && error.response.data) {
    return error.response.data.message || 'An error occurred';
  }
  return error.message || 'An error occurred';
};
